import { ApiService } from './api';
import { ApiResponse } from '../types/auth';
import {
  SettingsResponse,
  UpdateSettingsRequest,
  DriverGroupVisibilityResponse,
  UpdateDriverGroupVisibilityRequest
} from '../types/settings';

export class SettingsService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getSettings(): Promise<ApiResponse<SettingsResponse>> {
    try {
      const response = await this.apiService.get<SettingsResponse>('/admin/settings');
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch settings',
        success: false
      };
    }
  }

  async updateSettings(request: UpdateSettingsRequest): Promise<ApiResponse<void>> {
    try {
      await this.apiService.post<void>('/admin/settings', request);
      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to update settings',
        success: false
      };
    }
  }

  async getDriverGroupVisibility(): Promise<ApiResponse<DriverGroupVisibilityResponse>> {
    try {
      const response = await this.apiService.get<DriverGroupVisibilityResponse>(
        '/admin/settings/driver-group-visibility'
      );
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch driver group visibility',
        success: false
      };
    }
  }

  async updateDriverGroupVisibility(
    request: UpdateDriverGroupVisibilityRequest
  ): Promise<ApiResponse<void>> {
    try {
      await this.apiService.post<void>('/admin/settings/driver-group-visibility', request);
      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to update driver group visibility',
        success: false
      };
    }
  }

  async backupDatabase(): Promise<ApiResponse<{ message: string }>> {
    try {
      const response = await this.apiService.get<{ message: string }>('/automation/backup-database');
      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to back up database',
        success: false
      };
    }
  }
}

export const settingsService = new SettingsService();
